import * as yup from 'yup';
import { JavaScriptTransformIcon } from '../../../../assets';
import { validationsMessages } from 'lib';

export const createJavascriptTransformConfig: {
    [key: string]: {
        imgSrc: string;
        headingText?: string;
        iconStyles?: React.CSSProperties;
    };
} = {
    'javascript-transform': {
        imgSrc: JavaScriptTransformIcon,
        headingText: 'JavaScript Transform',
        iconStyles: { display: 'none' },
    },
};

export interface JavascriptTransformFormValues {
    funcName: string;
    jsBase64: string;
}

export const CreateJavascriptTransformDefaults = {
    funcName: 'xform',
    jsBase64: '',
};

export const CreateJavascriptTransformSchema = yup.object({
    funcName: yup
        .string()
        .default('xform')
        .required(validationsMessages.required),
    jsBase64: yup.string().required(validationsMessages.required),
});
